// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type {
	RequestTypeIssueSecurityStatus,
	RequestTypeRestrictionStatus,
	TicketType,
	TicketTypeData,
} from '../../../common/types.tsx';

const setRequestTypeSecurity =
	(
		requestTypeId: number,
		requestTypeSecurityStatus?: RequestTypeRestrictionStatus,
		issueSecurityStatus?: RequestTypeIssueSecurityStatus,
	): Action<TicketTypeData> =>
	({ getState, setState }) => {
		const { ticketTypes } = getState();

		const requestType = ticketTypes[String(requestTypeId)]?.currentState;

		const updatedRequestType: TicketType = {
			...requestType,
			...(requestTypeSecurityStatus && { restrictionStatus: requestTypeSecurityStatus }),
			...(issueSecurityStatus && { issueSecurityStatus }),
		};

		setState({
			ticketTypes: {
				...ticketTypes,
				[String(requestTypeId)]: { currentState: updatedRequestType, updateState: {} },
			},
		});
	};

export default setRequestTypeSecurity;
